import { useParams, Navigate, Outlet, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState, setLocale } from 'config/user/store'

const allowedCodes = ['en', 'fr', 'pt', 'de', 'es', 'it', 'zu']
const DEFAULT_LANG = 'en'

export const LanguageWrapper = () => {
  const { lang } = useParams()
  const { pathname, search } = useLocation()
  const dispatch = useDispatch()
  const currentLang = useSelector((state: RootState) => state.locale.lang)
  const langStr = String(lang)
  const langExist = allowedCodes.includes(langStr)
  const currentLangIsValid = allowedCodes.includes(currentLang)

  useEffect(() => {
    if (langExist && langStr !== currentLang) {
      dispatch(setLocale(langStr))
    }
  }, [langExist, langStr, currentLang, dispatch])
  const getFallbackLang = () => {
    return currentLangIsValid ? currentLang : DEFAULT_LANG
  }
  const replaceLangInPath = () => {
    const segments = pathname.split('/')
    if (segments[1] && allowedCodes.includes(segments[1])) {
      segments[1] = getFallbackLang()
    } else {
      segments.splice(1, 0, getFallbackLang())
    }
    return segments.join('/') + search
  }
  if (!langExist) {
    return <Navigate to={replaceLangInPath()} replace />
  }
  return <Outlet />
}
